import { render, staticRenderFns } from "./CustomerDetailPage.vue?vue&type=template&id=08db3e21&scoped=true&"
import script from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailPage.vue?vue&type=style&index=0&id=08db3e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db3e21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VTab,VTabItem,VTabs})
